<div class="overview-section">
  <div class="overview-heading-wrapper">
    <p class="overview-label">Real-Time Production Visibility</p>
    <h2 class="overview-heading">Every Order, Cost &amp; Quality Check — Live</h2>
    <p class="overview-subtitle">
      Production orders, quality pass rates, capacity utilization, and cost variances —
      all live, on one dashboard.
    </p>
  </div>

  <div class="overview-frame">
    <img src="images/modules/dashboard.PNG" alt="orderYaa Manufacturing dashboard showing production orders, quality pass rate, capacity utilization, and cost variances" />
  </div>
</div>
